/**
 * Sync hotspot markers with feature accordion panels.
 */
(function () {
  function initHotspots(root) {
    if (root.dataset.hotspotsBound === '1') {
      return;
    }
    root.dataset.hotspotsBound = '1';

    var items = Array.from(root.querySelectorAll('[data-hotspot-item]'));
    var markers = Array.from(root.querySelectorAll('[data-hotspot-marker]'));

    if (!items.length) {
      return;
    }

    function setExpanded(item, expanded) {
      var toggle = item.querySelector('[data-hotspot-toggle]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    function activate(index) {
      var idx = String(index);
      items.forEach(function (item) {
        var active = item.getAttribute('data-hotspot-item') === idx;
        item.classList.toggle('is-active', active);
        setExpanded(item, active);
      });
      markers.forEach(function (marker) {
        marker.classList.toggle('is-active', marker.getAttribute('data-hotspot-marker') === idx);
      });
    }

    markers.forEach(function (marker) {
      marker.addEventListener('click', function () {
        activate(marker.getAttribute('data-hotspot-marker'));
      });
    });

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-hotspot-toggle]');
      if (!toggle) {
        return;
      }
      toggle.addEventListener('click', function () {
        var idx = item.getAttribute('data-hotspot-item');
        if (item.classList.contains('is-active')) {
          item.classList.remove('is-active');
          setExpanded(item, false);
          markers.forEach(function (marker) {
            if (marker.getAttribute('data-hotspot-marker') === idx) {
              marker.classList.remove('is-active');
            }
          });
          return;
        }
        activate(idx);
      });
    });

    var initial = root.querySelector('[data-hotspot-item].is-active');
    if (initial) {
      activate(initial.getAttribute('data-hotspot-item'));
    } else if (items[0]) {
      activate(items[0].getAttribute('data-hotspot-item'));
    }
  }

  document.querySelectorAll('[data-product-feature-hotspots]').forEach(initHotspots);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-product-feature-hotspots]');
    if (root) {
      initHotspots(root);
    }
  });
})();